import React from 'react';
import { C } from 'src/base/texts/C';

interface NumberCircleProps {
  children: string;
}

const NumberCircle: React.FC<NumberCircleProps> = (
  props: NumberCircleProps,
): JSX.Element => (
  <div
    style={{
      height: 70,
      width: 70,
      marginLeft: 'auto',
      marginRight: 'auto',
      backgroundColor: '#e1eefe',
      borderRadius: '50%',
      display: 'flex',
      border: '3px solid #3272ef',
      boxShadow: 'rgba(0, 0, 0, 0.2) 1px 2px 3px',
    }}
  >
    <div
      style={{
        margin: 'auto',
        fontSize: 23,
        fontWeight: 'bold',
      }}
    >
      <C>{props.children}</C>
    </div>
  </div>
);

export default NumberCircle;
